export default {
  ShowTransfer: 'ShowTransfer',
  ShowCAReceipt: 'ShowCAReceipt',
  Save: 'Save',
  SaveAdd: 'SaveAdd',
  SaveClose: 'SaveClose',
  // Hoãn
  Postpone: 'Postpone',
  NextVoucher: 'NextVoucher',
  BackVoucher: 'BackVoucher',
  SaveView: 'SaveView',
  Ok: 'Ok',
  Delete: 'Delete',
  All: 'All',
  Follow: 'Follow',
  Unfollow: 'Unfollow',
  Active: 'Active',
  Unactive: 'Unactive',
  Edit: 'Edit',
  Duplicate: 'Duplicate',
  CreateFromCurrent: 'CreateFromCurrent',
  Add: 'Add',
  Approve: 'Approve',
  Reject: 'Reject',
  View: 'View',
  Posted: 'Posted',
  UnPosted: 'UnPosted',
  Estimate: 'Estimate',
  NextStep: 'NextStep',
  BackStep: 'BackStep',
  ViewAccount: 'ViewAccount',
  ViewQuantity: 'ViewQuantity',
  AddAutoBusiness: 'AddAutoBusiness',
  GenerateData: 'GenerateData',
  GenerateCaPaymentSalary: 'GenerateCaPaymentSalary',
  Refresh: 'Refresh',
  ChangeStatusPosted: 'ChangeStatusPosted',
  Copy: 'Copy',
  ShowWithDrawCash: 'ShowWithDrawCash',
  ShowWithDrawDeposit: 'ShowWithDrawDeposit',
  ShowWithDrawTransfer: 'ShowWithDrawTransfer',
  ShowWithDrawSalaryTransfer: 'ShowWithDrawSalaryTransfer',
  ShowBUTreasuryFundTransferSalary: 'ShowBUTreasuryFundTransferSalary',
  ShowBUTreasuryFundTransferInsurancePayment: 'ShowBUTreasuryFundTransferInsurancePayment',
  GLVoucherDetail: 'GLVoucherDetail',
  SaveParalell: 'SaveParalell',
  InsertRowGrid: 'InsertRowGrid',
  DeleteRowGrid: 'DeleteRowGrid',
  PostponeParalell: 'PostponeParalell',
  Cancel: 'Cancel',
  SettingAccount: 'SettingAccount',
  Import: 'Import',
  SaveApprove: 'SaveApprove',
  // Gửi phê duyệt
  SendApproval: 'SendApproval',
  Quit: 'Đóng',
  Print: 'Print',
  // Bảng kê
  BUVoucherListPlanned: 'BUVoucherListPlanned',
  BUVoucherListNotPlanned: 'BUVoucherListNotPlanned',
  BUVoucherListReceipExpense: 'BUVoucherListReceipExpense',
  BUVoucherListRealExpense: 'BUVoucherListRealExpense',
  BUVoucherListOther: 'BUVoucherListOther',

  // Sinh các loại giấy rút
  GenerateBUPlanWithdrawTransferDetail: 'GenerateBUPlanWithdrawTransferDetail', // Giấy rút dự toán tiền mặt
  GenerateBUPlanWithdrawDepositDetail: 'GenerateBUPlanWithdrawDepositDetail', // Giấy rút dự toán tiền gửi
  GenerateCAReceiptWithdrawDetail: 'GenerateCAReceiptWithdrawDetail',
  // In chứng từ
  Print_C213_TT772017_ST: 'C213_TT772017_ST',

  // Hóa đơn
  CreateSaleVoucher: 'CreateSaleVoucher',
  ReleaseInvoice: 'ReleaseInvoice',
  CancelInvoice: 'CancelInvoice',
  SendInvoice: 'SendInvoice',
  SendNotify: 'SendNotify',
  CreateSaleVoucherMulti: 'CreateSaleVoucherMulti',
  CreateAdjustSaleInvoice: 'CreateAdjustSaleInvoice', // Lập hóa đơn điều chỉnh vqphong - 22.09.2022
  SaleInvoiceReplace: 'SaleInvoiceReplace', // Lập hóa đơn thay thế
  DownloadInvoice: 'DownloadInvoice', // Tải hóa đơn
  ConvertToPaperVoucher: 'ConvertToPaperVoucher', // Chuyển thành hóa đơn giấy
  GenerateInvoice: 'GenerateInvoice', // Lập hóa đơn
  PublishInvoiceMulti: 'PublishInvoiceMulti',
  PublishInvoice: 'PublishInvoice',

  // Nhập số dư
  AccountBalance: 'AccountBalance',
  // Đóng thuế
  PayTax: 'PayTax',

  // Lương
  SalaryAllocation: 'SalaryAllocation',
  // sinh chi tiền gửi
  GenerateDrawSalary: 'GenerateDrawSalary',
  GenerateDataFundSalary: 'GenerateDataFundSalary', // sinh hạch toán chi phí lương
  GenerateDataFundInsurance: 'GenerateDataFundInsurance', // sinh hạch toán chi phí bảo hiểm
  SysRole: 'SysRole',
  GenerateBaDeposit: 'GenerateBaDeposit', // sinh thu tiền gửi
  GenerateReceiptFixedAsset: 'GenerateReceiptFixedAsset', // Sinh thu tiền mặt bán TSCĐ
  GenerateInvoiceFixedAsset: 'GenerateInvoiceFixedAsset', // sinh hóa đơn bán hàng cố định

  InvolveVoucher: 'InvolveVoucher', // Chứng từ liên quan

  RestoreBackup: 'RestoreBackup', // PHục hồi sao lưu

  CopyVoucher: 'CopyVoucher', // Copy chứng từ

  GenerateAccountingPaymentBudget: 'GenerateAccountingPaymentBudget',
  // Báo cáo mẫu trộn
  DownloadMergeReport: 'DownloadMergeReport', // Tải về báo cáo mẫu trộn
  CreateFormular: 'CreateFormular', // Lập công thức

  Inward: 'Inward', // Nhập kho
  Outward: 'Outward', // Xuất kho
  IncrementCCDC: 'IncrementCCDC',
  DecrementCCDC: 'DecrementCCDC',

  // Kiểm tra công thức thiết lập
  CheckFormula: 'CheckFormula',

  // Xóa tất cả Tài khoản con
  DeleteChildAccounts: 'DeleteChildAccounts',

  GenerateVoucherTreasuryWithdraw: 'GenerateVoucherTreasuryWithdraw', //Sinh phiếu rút tiền kho bạc
  //in chứng từ báo nợ
  DebitVoucherDownload: 'DebitVoucherDownload',

  // Hoá đơn meinvoice
  SelectVoucher: 'SelectVoucher',
  UnselectedVoucher: 'UnselectedVoucher',
  ViewInvoice: 'ViewInvoice',
  CreateVoucherFromInvoice: 'CreateVoucherFromInvoice',
  NoAccounted: 'NoAccounted',

  //#region Tiện ích
  GenerateAccountTransfer: 'GenerateAccountTransfer', // Sinh phiếu kết chuyển
  //#endregion
};
